import { __assign, __rest } from "tslib";
import React from 'react';
import { compose } from '@bem-react/core';
import { withRegistry } from '@bem-react/di';
import { withControl } from '../withControl/withControl@desktop';
import { withAutoFocus } from '../withAutoFocus/withAutoFocus';
import { cnTextinput, Textinput as TextinputCommon } from './Textinput';
import { textinputRegistry } from './Textinput.registry/desktop';
var TextinputPresenter = function (_a) {
    var className = _a.className, hovered = _a.hovered, props = __rest(_a, ["className", "hovered"]);
    return (React.createElement(TextinputCommon, __assign({}, props, { className: cnTextinput({ hovered: hovered }, [className]) })));
};
export * from './Textinput';
export var Textinput = compose(withRegistry(textinputRegistry), withControl, withAutoFocus)(TextinputPresenter);
